import React from "react";
import Background from "../../components/Background/Background";
import MissionValues from "../../components/MissionValues/MissionValues";
import Team from "../../components/Team/Team"; // Import Team and teamMembers
import Footer from '../../components/Footer/Footer'; // Import Footer component
import '../../resources/styling/GlobalStyles.css';
import './AboutPage.css';

const AboutUs = () => {
  return (
    <div className="page-container"> {/* Ensures footer stays at the bottom */}
      <main className="main-content">
        {/* Background Section */}
        <Background />

        {/* Mission & Values Section */}
        <MissionValues />
      </main>

      {/* Footer Section */}
      <Footer />
      
    </div>
  );
};

export default AboutUs;
